<template>
  <div class="preset block">
    <div class="preset__label" v-if="preset.label">
      {{ preset.label }}
    </div>

    <h3>{{ preset.name }}</h3>

    <div class="preset__products">
      <div v-for="(feature, i) in preset.features" :key="i" class="preset__product">
        <div class="preset__product-icon" :style="`background-color: ${feature.color}`">
          <icon :icon="feature.icon" />
        </div>

        <h4>{{ feature.category }}</h4>

        <ul v-for="(item, j) in feature.items[0]" :key="j">
          <li>{{ item }}</li>
        </ul>
      </div>
    </div>

    <div class="preset__price" v-if="preset.incentive_type === 'price'">
      <div>Nu eerste {{ preset.incentive_duration }} maanden</div>
      <div class="preset__price-value">
        {{ preset.incentive_value | toDisplayPrice }}
      </div>
      <div>Daarna {{ preset.price | toDisplayPrice }} per maand</div>
    </div>
    <div class="preset__price" v-else-if="preset.incentive_type === 'procent'">
      <div>Nu eerste {{ preset.incentive_duration }} maanden</div>
      <div class="preset__price-value">
        {{ preset.incentive_value }}<sup>%</sup>
      </div>
      <div>korting op uw abonnement</div>
    </div>
    <div class="preset__price" v-else-if="preset.incentive_type === 'package'">
      <div>Prijs per maand</div>
      <div class="preset__price-value">{{ preset.price | toDisplayPrice }}</div>
      <div>{{ preset.incentive_text }}</div>
    </div>
    <div class="preset__price" v-else>
      <div>Prijs per maand</div>
      <div class="preset__price-value">{{ preset.price | toDisplayPrice }}</div>
    </div>

    <button @click="$emit('select')">Bestellen</button>
  </div>
</template>

<script>
import Icon from './icon.vue'
import priceFilters from '../filters/priceFilters'

export default {
  components: { Icon },
  props: {
    preset: Object
  },
  computed: {
    products () {
      return this.preset.categories.filter(
        c => c.active === 1 && c.parent === c.name && c.name !== 'INCENTIVE'
      )
    }
  },
  filters: {
    toDisplayPrice: priceFilters.toDisplayPrice
  }
}
</script>

<style scoped lang="scss">
.preset {
  flex: 1;
  position: relative;
  text-align: center;
  height: max-content;

  &:hover {
    box-shadow: 0px 0px 2px color('preset__hover');
  }
}

.preset__label {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  transform: translate(0, -100%);
  padding: 6px 20px;
  text-transform: uppercase;
  color: #fff;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  font-weight: 300;
  letter-spacing: 1px;
  width: 180px;
  margin: 0 auto;

  background: color('preset__label');
}

button {
  transform: translate(0, 100%);
}

h3 {
  font-size: 20px;
  margin-bottom: 40px;
  text-align: center;

  &::after {
    content: "";
    display: block;
    width: 100px;
    height: 2px;
    background-color: color('title_underline');
    margin: 15px auto;
  }
}

.preset__price {
  font-weight: 600;

  .preset__price-value {
    font-size: 50px;
    font-weight: 700;

    sup {
      font-size: 0.5em;
    }
  }
}

.preset__title {
  font-weight: 700;
  font-size: 1.5em;

  margin-bottom: 10px;
}

.preset__product {
  position: relative;
  text-align: left;
  padding-left: 50px;
  padding-bottom: 20px;
  border-bottom: 1px solid $color-border;
  margin-bottom: 30px;

  h4 {
    font-size: 18px;
    font-weight: 600;
  }

  ul {
    list-style: none;
    padding: 0;
  }
  ul li {
    font-weight: 300;
    font-size: 14px;
    line-height: 25px;
  }
}

.preset__product-icon {
  position: absolute;
  top: -10px;
  left: 0;
  width: 40px;
  height: 40px;
  border-radius: 100%;
}
</style>
